var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model.number",
        value: _vm.internalValue,
        expression: "internalValue",
        modifiers: { number: true }
      },
      { name: "focus", rawName: "v-focus" }
    ],
    class: ["form-control", _vm.noSpinner ? "no-spinner" : ""],
    attrs: {
      type: "number",
      id: _vm.key,
      min: _vm.min,
      max: _vm.max,
      step: _vm.step,
      required: _vm.required,
      disabled: _vm.disabled
    },
    domProps: { value: _vm.internalValue },
    on: {
      input: [
        function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.internalValue = _vm._n($event.target.value)
        },
        _vm.onChange
      ],
      blur: function($event) {
        return _vm.$forceUpdate()
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ef7f458", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef7f458","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/NumberInput.vue
// module id = 671
// module chunks = 0